export const Camera1 = require("./camera1.png");
export const Camera2 = require("./camera2.png");
export const Camera3 = require("./camera3.png");
export const Aadhaar = require("./aadhaar.png");
export const PANCard = require("./pancard.png");
export const VoterIDCard = require("./votercard.png");
export const DrivingLicence = require("./license.png");
export const AD_DL = require("./AD_DL.png");
export const AD_AC = require("./AD_AC.png");
export const AD_RC = require("./AD_RC.png");
export const AD_VC = require("./AD_VC.png");
export const ID_PC = require("./ID_PC.png");
export const OTHER_PROOF = require("./OTHER_PROOF.png");
export const SelfieX1 = require("./Selfie-X-01.png");
export const SelfieX2 = require("./Selfie-X-02.png");
export const SelfieX3 = require("./Selfie-X-03.png");
export const SelfieT1 = require("./Selfie-T-01.png");
export const SelfieT2 = require("./Selfie-T-02.png");
export const SelfieT3 = require("./Selfie-T-03.png");
export const PWIDX1 = require("./PWID-X-01.png");
export const PWIDX2 = require("./PWID-X-02.png");
export const PWIDX3 = require("./PWID-X-03.png");
export const PWIDT1 = require("./PWID-T-01.png");
export const PWIDT2 = require("./PWID-T-02.png");
export const PWIDT3 = require("./PWID-T-03.png");
export const Group = require("./group.png");
export const SelfieFrame = require("./selfie-frame.png");
export const PWIDFaceFrame = require("./Photo-with-ID-face.png");
export const PWIDIDFrame = require("./Photo-with-ID-id.png");
export const AddressProofFrame = require("./address-proof-frame.png");
export const IDProofFrame = require("./ID_Proof_frame.png");
export const VideoFrame = require("./video-frame.png");
export const ThankYouImage = require("./thank-you.png");
export const HomeX1 = require("./Home-X-01.png");
export const HomeX2 = require("./Home-X-02.png");
export const HomeX3 = require("./Home-X-03.png");
export const HomeT1 = require("./Home-T-01.png");
export const HomeT2 = require("./Home-T-02.png");
export const HomeT3 = require("./Home-T-03.png");
